import type {
  CapacitorGlobal,
  PluginListenerHandle as IPluginListenerHandle,
  RegisterPlugin,
} from '@capacitor/core/types/definitions';
import type { WebPlugin as IWebPlugin } from '@capacitor/core/types/web-plugin';
import type {
  CapacitorGlobal as CapacitorGlobalV7,
  PluginListenerHandle as IPluginListenerHandleV7,
  RegisterPlugin as RegisterPluginV7,
} from 'capacitor7-core/types/definitions';
import type { WebPlugin as IWebPluginV7 } from 'capacitor7-core/types/web-plugin';

type CapacitorGlobalCompat = CapacitorGlobal | CapacitorGlobalV7;
type RegisterPluginCompat = RegisterPlugin | RegisterPluginV7;
type WebPluginCompat = typeof IWebPlugin | typeof IWebPluginV7;

export type PluginListenerHandle = IPluginListenerHandle | IPluginListenerHandleV7;
// We are intentionally using a mutable export so that we can mimic the original import
// syntax for Capacitor plugins, while still dynamically loading the correct capacitor version.
// Don't remove or try to fix the skipcq, as this syntax is mandatory for the compatibility bridge.
// skipcq: JS-E1009
export let Capacitor: CapacitorGlobal;
// skipcq: JS-E1009
export let registerPlugin: RegisterPlugin;
// skipcq: JS-E1009
export let WebPlugin: typeof IWebPlugin;

const load = (exported: {
  Capacitor: CapacitorGlobalCompat;
  registerPlugin: RegisterPluginCompat;
  WebPlugin: WebPluginCompat;
}) => {
  Capacitor = exported.Capacitor as CapacitorGlobal;
  registerPlugin = exported.registerPlugin as RegisterPlugin;
  WebPlugin = exported.WebPlugin as typeof IWebPlugin;
};

export default load;
